import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {ArmFormComponent} from './arm-form.component';
import {MaterialModule} from '../../material.module';
import {InfraModule} from 'ac-infra';
import {FormsModule} from '@angular/forms';


@NgModule({
  declarations: [ArmFormComponent],
  exports: [
    ArmFormComponent
  ],
    imports: [
        CommonModule,
        MaterialModule,
        InfraModule,
        FormsModule
    ]
})
export class ArmFormModule { }
